<template>
  <div class="upload-wrapper">
    <el-upload action="//upload.qiniup.com/" type="drag" accept="image/*" :show-file-list="false" :before-upload="beforeUpload" :on-success="handleSuccess" :data="data" :on-progress="handelProgress">
      <slot>
        <i class="el-icon-plus"></i>
      </slot>
      <el-progress :percentage="percentage" :show-text="false" v-if="percentage"></el-progress>
    </el-upload>
  </div>
</template>
<script>
import { getToken } from '@/api/common'
import md5 from 'md5'
export default {
  name: 'UploadImage',
  props: {
    value: String
  },
  data() {
    return {
      data: { token: '', key: '' },
      imageInfo: {},
      percentage: 0
    }
  },
  methods: {
    beforeUpload(file) {
      let key =
        'zaiart/admin/image/' +
        md5(file.name + new Date().getTime()) +
        file.name.substr(file.name.lastIndexOf('.'))
      return new Promise((resolve, reject) => {
        getToken()
          .then(response => {
            this.data.token = response.data
            this.data.key = key
            resolve(true)
          })
          .catch(err => {
            reject(new Error(err))
          })
      })
    },
    handelProgress(event, file) {
      this.percentage = event.percent
    },
    handleSuccess(response, file) {
      let image = new Image()
      image.src = `https://img.zai-art.com/${response.key}`
      image.onload = () => {
        this.imageInfo = {
          url: image.src,
          width: image.width,
          height: image.height
        }
        this.percentage = 0
        this.uploaded(this.imageInfo)
      }
    },
    uploaded(imageInfo) {
      this.$emit('input', imageInfo.url)
      this.$emit('uploaded', imageInfo)
    }
  }
}
</script>

<style>
.upload-wrapper .el-progress-bar__outer,
.upload-wrapper .el-progress-bar__inner {
  border-radius: 0;
}
</style>
